<template>
    <div style="position: relative;" :class="classe[0]">
      <!-- Text xhr select {{ this.listagem.length }} <br>
      value {{ value }} <br>
      disabled {{ this.existeTodosParametrosObrigatorios }} <br> -->

      <!-- {{ this.$props.parameters }} -->
      <div class="d-flex">
        <FormulateInput     
            :name="name"                 
            type="select"            
            :label="label"
            :validation="validation"     
            :placeholder="placeholder"
            :class="this.$props.classe[1] + ' col-10 pa-0' + (!existeTodosParametrosObrigatorios ? ' desativar-select' : '')"
            :options="listagemMontada"
            :disabled="!existeTodosParametrosObrigatorios"
            style="margin-bottom: 0px !important;"
            autocomplete="off"
            v-model="value"
        />

        <div class="col-2 pa-1 d-flex flex-column justify-end">
          <SGPIconComponent 
            :icon="filtroSelecionado ? 'mdi-check-circle' : 'mdi-close-circle'" 
            :color="filtroSelecionado ? '#198754' : '#df323b'" 
          />
        </div>
      </div>

      

    </div>
</template>
<script>

export default {
  name: "SelectXhrComponent",

  props: {
    configInput: {
      type: Object,
      required: true
    },
    parameters: {
      type: Object,
      required: false
    },
    value: {
      type: String,
      required: false,
    },
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
      default: "Salvar",
    },
    placeholder: {
      type: String,
      required: true,
    },    
    classe: {
      type: Array,
      required: true,
    },    
  },

  data() {
    return {
      timer: null,
      tempoEspera: 500,
      textoDigitado: '',
      textoConsultado: '',
      listagem: [],
      
      selecionado: false,
      existeTodosParametrosObrigatorios: false,
      ultimoPayload: {}
    }
  },

  computed: {
    filtroSelecionado () {
      return this.selecionado
    },

    listagemMontada() {
      return this.listagem.map(obj => {
          return { value: this.getList('keyList', obj, true), label: this.getList('labelList', obj), objeto: obj}
      })
    }
  },

  methods: {
    async callDynamicAction(actionName, payload) {
      return await this.$store.dispatch(actionName, payload);
    },

    actionNameExists(actionName)
    {
      return Object.prototype.hasOwnProperty.call(this.$store._actions, actionName);
    },

    payload() {
      return this.getParameters()      
    },

    getParameters() {
      let jsonParameters = {};
      if (this.$props.configInput.getParameters.length) {
        this.$props.configInput.getParameters.forEach(obj => {
          let valueKey = this.getValueByPath(this.$props.parameters, obj?.path)
          if (valueKey != 'undefined') {
            jsonParameters[obj?.payloadKey] = valueKey
          }          
        });
      }
      return jsonParameters      
    },

    requiredParameters() {  
      if (this.$props.configInput?.requiredParameters) {
        if (this.$props.configInput?.requiredParameters.length) {
          this.$props.configInput.requiredParameters.forEach(obj => {
            let valueKey = this.getValueByPath(this.$props.parameters, obj?.path)
            if (valueKey != 'undefined' && valueKey != '') {
              this.existeTodosParametrosObrigatorios = true              
            } else {
              this.existeTodosParametrosObrigatorios = false              
              this.listagem = []              
            }          
          });
        }
      }
    }, 

    returnParameters(item) {
      let jsonParameters = [{
        "name" : this.$props.name,
        "model" : this.getList('keyList', item, true)
      }]
      
      if(this.$props.configInput?.returnParameters) {        
        if (this.$props.configInput?.returnParameters.length) {
          this.$props.configInput?.returnParameters.forEach(obj => {
            let valueKey = this.getValueByPath(item, obj?.path)
            if (valueKey != 'undefined') {
              jsonParameters.push({
                "name" : obj?.payloadKey,
                "model" : valueKey
              })
            }          
          });
        }
      }
            
      return jsonParameters      
    },

    async focusInput() {
      if (this.value == '' && this.textoDigitado != '') {
        if (this.actionNameExists(this.$props.configInput?.actionName)) {
          this.listagem = await this.callDynamicAction(this.$props.configInput?.actionName, this.payload())          
        }   
      }
    },

    getValueByPath(obj, path) {
      const result = path.split('.').reduce((acc, key) => {
        if (Array.isArray(acc)) {
          // Acessa a chave em cada item do array
          return acc.map(item => item[key]).filter(v => v !== undefined);
        }
        return acc && acc[key];
      }, obj);

      if (Array.isArray(result)) {
        // Se for array, junta os valores em uma string
        return result.filter(v => v !== undefined && v !== null).join(', ');
      }

      // Retorna string simples ou string vazia
      return result !== undefined && result !== null ? String(result) : '';
    },

    async getListagem() {
      let payload = this.payload()
      if (JSON.stringify(this.ultimoPayload) != JSON.stringify(payload)) {
        this.ultimoPayload = payload
        if (this.existeTodosParametrosObrigatorios) {
          this.limparSelecao()
          if (this.actionNameExists(this.$props.configInput?.actionName)) {
            this.listagem = await this.callDynamicAction(this.$props.configInput?.actionName, payload)
          }            
        }
      }
    },

    getList(arrCampos, item, showKeyNameList = false) {
      let labelList = ''
      if(this.$props.configInput[arrCampos].length) {
        this.$props.configInput[arrCampos].forEach((value, index) => {
          if (index > 0) {
            labelList += ' - '
          }
          if (showKeyNameList && this.$props.configInput['ShowkeyNameList'] && typeof this.$props.configInput['ShowkeyNameList'] != 'undefined') {              
            labelList += value +': '+ item[value]
          } else {
            labelList += item[value]
          }          
        });
      }

      return labelList
    },

    itemSelecionado(item) {
      const itemX = this.listagemMontada.find(o => o.value === item)   
      //this.$props.value = this.getList('keyList', itemX.objeto, true)     
      this.selecionado = true
      this.$emit('update', 
        this.returnParameters(itemX.objeto)
      )
    },

    limparSelecao() {
      this.selecionado = false

      let jsonParameters = [{
        "name" : this.$props.name,
        "model" : ''
      }]
      
      if(this.$props.configInput?.returnParameters) {        
        if (this.$props.configInput?.returnParameters.length) {
          this.$props.configInput?.returnParameters.forEach(obj => {
            jsonParameters.push({
                "name" : obj?.payloadKey,
                "model" : ''
              })        
          });
        }
      }

      this.$emit('update', jsonParameters)
    }
  },

  watch: {
    value () {
      if (this.$props.value != ''
      ) {                    
        this.selecionado = true
        const itemX = this.listagemMontada.find(o => o.value === this.$props.value)   
        this.$emit('update', 
          this.returnParameters(itemX.objeto)
        )
      }     
    },

    parameters () {
      this.requiredParameters()
      this.getListagem()
    }
  }
}
</script>

<style scoped>
.dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  max-height: 160px; /* Aproximadamente 5 itens visíveis */
  overflow-y: auto;
  background: white;
  border: 1px solid #ccc;
  z-index: 10;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
  margin-left: 12px;
}

.dropdown-item {
  padding: 8px 12px;
  cursor: pointer;
}

.dropdown-item:hover {
  background-color: #f0f0f0;
}


/* .formulate-input[data-classification=select] select {
  background-color: #f8f8f8 !important;   
} */


::v-deep(.desativar-select select) {  
  background-color: #f8f8f8 !important;
}


</style>